var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-default btn-number remove-product",
        attrs: {
          type: "button",
          "data-type": "minus",
          disabled: _vm.quantity <= _vm.min,
        },
        on: { click: _vm.decrement },
      },
      [_c("span", { staticClass: "glyphicon glyphicon-minus" })]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model.number",
          value: _vm.quantity,
          expression: "quantity",
          modifiers: { number: true },
        },
      ],
      staticClass: "form-control input-number space-bottom-0",
      attrs: { type: "number", min: _vm.min, max: _vm.max },
      domProps: { value: _vm.quantity },
      on: {
        input: function ($event) {
          if ($event.target.composing) return
          _vm.quantity = _vm._n($event.target.value)
        },
        blur: function ($event) {
          return _vm.$forceUpdate()
        },
      },
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-default btn-number add-product",
        attrs: {
          type: "button",
          "data-type": "plus",
          disabled: _vm.quantity >= _vm.max || _vm.maxedOut,
        },
        on: { click: _vm.increment },
      },
      [_c("span", { staticClass: "glyphicon glyphicon-plus" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }